import { render, staticRenderFns } from "./LegalRatingSelector.vue?vue&type=template&id=3387e873&scoped=true&"
import script from "./LegalRatingSelector.vue?vue&type=script&lang=js&"
export * from "./LegalRatingSelector.vue?vue&type=script&lang=js&"
import style0 from "./LegalRatingSelector.vue?vue&type=style&index=0&id=3387e873&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3387e873",
  null
  
)

export default component.exports